var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"page-header-about",class:[_vm.data.class, _vm.data.staticClass]},[_c('a',{attrs:{"href":_vm.props.aboutUrl}},[_vm._v("About")])])}
var staticRenderFns = []

export { render, staticRenderFns }